<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
	@import url("style/style.css");
	@import url("style/public.css");
	* {
	    padding: 0;
	    margin: 0;
	    box-sizing: border-box;
	    font-family: PingFangSC;

	  }
	  html,body{
	    font-size: 14px;
	  }
	/* 	html{
			font-size: calc(100vw / 3.75);
		} */
		img{
			width: 100%;
			height: 100%;
		}
	.colfff{
		color: #fff;
	}
	.cursor{
		cursor: pointer;
	}
	.min-width{
		min-width: 1400px;
	}

	.el-dropdown,.el-dropdown-menu__item{
		font-size: 12px;
		line-height: 50px;
	}
	.el-dropdown-menu__item{
		width: 100px;
		line-height: 40px;
		text-align: center;
		padding: 0;
	}
	.header-box{
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		z-index: 9;
		padding: 30px 75px;
	}
	.logo-img{
		width: 140px;
		height: 50px;
	}
	.el-popper .popper__arrow, .el-popper .popper__arrow::after{
		opacity: 0;
	}
	.el-dropdown-menu{
		background-color:rgb(0 0 0 / 20%);
		border:0;
		padding: 0;
		transform: translateX(20%);
		top:52px !important;
	}
	.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
		color:#fff;
		background-color: #202031;
	}
	.router-box{
		width: 600px;
		min-width: 600px;
	}
	.pc-30-box{
		margin: 0 1.5% 2% 1.5%;
		cursor: pointer;
	}
	.pc-hover-box{
		background: rgba(0, 0, 0, .7);
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		text-align: center;
		justify-content: center;
		transition: all 1s;
		opacity: 0;
		z-index: 3;
		font-size: 23px;
		font-weight: 300;
		color: #c3c3c3;
	}
	.pc-hover-box:hover{
		opacity: .9;
	}

	.pc-btn{
		width: 281px;
    height: 34.25px;
    line-height: 34.25px;
    background: #dcd9d9;
    text-align: center;
    margin: 50px auto;
    cursor: pointer;
    transition: all .3s;
    color: #000000;
    font-family: 'enLight';
    border-radius: 10px;
    display: block;
    letter-spacing: 2px;
	}
	.pc-btn:hover{
		background-color: #000000;
		color: #fff;
	}
	.v_html img{
		width: 100% !important;
	}
.classList .el-tabs__item{
  padding: 12px 0;
  text-align: center;
  width: 280px;
  font-size: 18px;
  font-family: 'SourceHanSansCNExtraLight';
  cursor: pointer;
  margin: 0 10px;
  height:auto;
  line-height: 1;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.classList .is-top{
  background: #f0f0f0;
  color: #5b5b5b;
}
.classList .is-active{
  background: #595959;
  color: #fff;
}
.classList .el-tabs__active-bar{
  display: none;
}
.classList .el-tabs__nav-prev{
  left: 7px;
}
.classList .el-tabs__nav-next {
    right: 7px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue